import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigateLinks } from '@/components';
import { driverMonitoringPageBreadcrumbs } from '../config';
import { DriverMonitoringView, MockModeToggle } from '../components';

export const DriverMonitoringPage = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => driverMonitoringPageBreadcrumbs(navigate),
    [navigate]
  );

  return (
    <section className='flex flex-col w-full h-full gap-6'>
      <NavigateLinks
        actualPage='Monitoreo de conductores'
        breadcrumbs={breadcrumbs}
      />
      <div className='flex justify-end px-4'>
        <MockModeToggle />
      </div>
      <DriverMonitoringView />
    </section>
  );
};

export default DriverMonitoringPage;
